<div class="corr-header-container">
  @if (isLoading) {
    <div class="loading-overlay">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  }

  <form #corrHeaderForm="ngForm" class="corr-header-form">
    <div class="section-header mb-3">
      <h5>Correspondent Information</h5>
    </div>

    <div class="row">
      <div class="col-md-6 mb-3">
        <label class="form-label">AM Email <span class="text-danger">*</span></label>
        <input
          class="form-control"
          type="email"
          [(ngModel)]="formData.amEmail"
          name="amEmail"
          #amEmailField="ngModel"
          email
          [required]="true">
        @if (amEmailField.invalid && amEmailField.touched) {
          <div class="text-danger">
            @if (amEmailField.errors?.required) {
              <small>AM Email is required</small>
            }
            @if (amEmailField.errors?.email) {
              <small>Please enter a valid email address</small>
            }
          </div>
        }
      </div>

      <div class="col-md-6 mb-3">
        <label class="form-label">Loan Number</label>
        <text-input
          [(ngModel)]="formData.loanNumber"
          name="loanNumber">
        </text-input>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6 mb-3">
        <label class="form-label">Lock Expiration Date</label>
        <text-input
          [(ngModel)]="formData.lockExpirationDate"
          name="lockExpirationDate"
          [readonly]="true">
        </text-input>
      </div>
    </div>

    <div class="section-header mb-3 mt-4">
      <h5>Company Information</h5>
    </div>

    <div class="row">
      <div class="col-md-6 mb-3">
        <label class="form-label">Company Name</label>
        <text-input
          [(ngModel)]="formData.companyName"
          name="companyName">
        </text-input>
      </div>

      <div class="col-md-6 mb-3">
        <label class="form-label">Company License</label>
        <text-input
          [(ngModel)]="formData.companyLicense"
          name="companyLicense">
        </text-input>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6 mb-3">
        <label class="form-label">Phone</label>
        <input
          class="form-control"
          [(ngModel)]="formData.phone"
          name="phone"
          [mask]="'(000) 000-0000'"
          [showMaskTyped]="true">
      </div>

      <div class="col-md-6 mb-3">
        <label class="form-label">Fax</label>
        <input
          class="form-control"
          [(ngModel)]="formData.fax"
          name="fax"
          [mask]="'(000) 000-0000'"
          [showMaskTyped]="true">
      </div>
    </div>

    <div class="section-header mb-3 mt-4">
      <h5>Processor Information</h5>
    </div>

    <div class="row">
      <div class="col-md-6 mb-3">
        <label class="form-label">Processor Name</label>
        <text-input
          [(ngModel)]="formData.processorName"
          name="processorName">
        </text-input>
      </div>

      <div class="col-md-6 mb-3">
        <label class="form-label">Processor Email</label>
        <input
          class="form-control"
          type="email"
          [(ngModel)]="formData.processorEmail"
          name="processorEmail"
          #processorEmailField="ngModel"
          email>
        @if (processorEmailField.invalid && processorEmailField.touched) {
          <div class="text-danger">
            <small>Please enter a valid email address</small>
          </div>
        }
      </div>
    </div>

    <div class="section-header mb-3 mt-4">
      <h5>Loan Officer Information</h5>
    </div>

    <div class="row">
      <div class="col-md-6 mb-3">
        <label class="form-label">Loan Officer Name</label>
        <text-input
          [(ngModel)]="formData.loanOfficerName"
          name="loanOfficerName">
        </text-input>
      </div>

      <div class="col-md-6 mb-3">
        <label class="form-label">Loan Officer Email</label>
        <input
          class="form-control"
          type="email"
          [(ngModel)]="formData.loanOfficerEmail"
          name="loanOfficerEmail"
          #loanOfficerEmailField="ngModel"
          email>
        @if (loanOfficerEmailField.invalid && loanOfficerEmailField.touched) {
          <div class="text-danger">
            <small>Please enter a valid email address</small>
          </div>
        }
      </div>
    </div>
  </form>
</div>
